import React from 'react';

import { GuideManagementPage } from '../../guides/components/GuideManagementPage';

export default function GuidesIndexPage() {
    return <GuideManagementPage />;
}
